import { render, staticRenderFns } from "./ordersettingactionapproveuser.vue?vue&type=template&id=b5c147d2&"
import script from "./ordersettingactionapproveuser.vue?vue&type=script&lang=js&"
export * from "./ordersettingactionapproveuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports